// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Gq","tab":"i_Gr","selected-tab":"i_Gs"};